export default __webpack_public_path__ + "static/media/avalancheLogo.8e786b59.svg";